<template>
  <div>
    <grid-row>
      <grid-col col-size="1">
        <btn-pill
          btn-size="s"
          v-if="isCurrentWeekDate()"
          @click="generateReport()">
          <font-awesome-icon :icon="icon.file"/>
          {{ $t('health.nutritionalPlan.exportPdf') }}
        </btn-pill>
      </grid-col>
    </grid-row>
    <week-plan-table class="margin-left-m margin-right-m margin-top-l margin-bottom-l" :data="weekPlan"/>

    <MealTypeDetails v-for="(mealType, index) in mealTypes" :key="index"
                     v-if="isCurrentWeekDate()"
                     :type="$t('health.nutritionalPlan.mealTypes')[index]" :meals="getMealsByType(mealType)"
                     class="margin-top-m"/>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Glucovibes-Nutritional plan"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="1115px"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <section class="pdf-item">
          <img src="../../assets/Logo_login.png" class="right margin-top-l"/>
          <h1 class="text-center">{{ $t('health.nutritionalPlan.menu') }}</h1>
          <week-plan-table class="aligned margin-left-m margin-right-m" :data="weekPlan"/>
          <div v-if="getMealsByType(mealTypes[0]).length > 0">
            <h2 class="margin-left-m margin-top-m">{{ $t('health.nutritionalPlan.mealTypes')[0] }}</h2>
            <meal-cards-group :meals="getMealsByType(mealTypes[0])" class="margin-top-m"/>
          </div>
        </section>

        <div v-for="(mealType, index) in mealTypes" :key="index">
          <section
            v-if="index % 2 === 1 && (getMealsByType(mealType).length > 0 || getMealsByType(mealTypes[index + 1]).length > 0)"
            class="pdf-item">
            <div class="html2pdf__page-break"/>
            <img src="../../assets/Logo_login.png" class="right margin-top-m"/>
            <div v-if="getMealsByType(mealType).length > 0">
              <h2 class="margin-left-m margin-top-m">{{ $t('health.nutritionalPlan.mealTypes')[index] }}</h2>
              <meal-cards-group :meals="getMealsByType(mealType)" class="margin-top-m"/>
            </div>
            <div v-if="index + 1 < mealTypes.length && getMealsByType(mealTypes[index + 1]).length > 0">
              <h2 class="margin-left-m">{{ $t('health.nutritionalPlan.mealTypes')[index + 1] }}</h2>
              <meal-cards-group :meals="getMealsByType(mealTypes[index + 1])" class="margin-top-m"/>
            </div>
          </section>
        </div>

      </section>
    </vue-html2pdf>
  </div>

</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faFileDownload} from '@fortawesome/pro-solid-svg-icons';
import WeekPlanTable from 'BRAND/components/nutritionPlan/WeekPlanTable';
import BtnPill from '@/components/shared/buttons/BtnPill';
import VueHtml2pdf from 'vue-html2pdf';
import MealCardsGroup from 'BRAND/components/nutritionPlan/MealCardsGroup';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import MealTypeDetails from 'BRAND/components/nutritionPlan/MealTypeDetails';

export default {
  name: 'GramsKiloModePlan',
  components: {
    WeekPlanTable,
    BtnPill,
    VueHtml2pdf,
    FontAwesomeIcon,
    MealCardsGroup,
    GridRow,
    GridCol,
    MealTypeDetails
  },
  props: {
    mealTypes: {
      default: []
    },
    selectedDay: {
      default: new Date()
    },
    weekPlan: {
      default: []
    },
    meals: {
      default: []
    }
  },
  data: () => {
    return {
      icon: {
        file: faFileDownload
      }
    };
  },
  methods: {
    generateReport () {
      this.$refs.html2Pdf.generatePdf();
    },
    isCurrentWeekDate () {
      const newDate = new Date();
      let selectedDate = new Date(this.selectedDay);
      selectedDate.setHours(0, 0, 0, 0);
      newDate.setHours(0, 0, 0, 0);

      const isFuture = this.selectedDay ? newDate.getTime() < selectedDate.getTime() : false;
      const sevenDaysMillis = 604800000;
      const minusSevenDaysDate = new Date(newDate.getTime() - sevenDaysMillis);
      const isPastWeek = minusSevenDaysDate.getTime() >= selectedDate.getTime();
      return !isFuture && !isPastWeek;
    },
    getMealsByType (mealType) {
      return this.meals.filter(meal => meal.type === mealType);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/GramsKiloModePlan.vue